import React from 'react';
import { Typography, Card, Grid } from '@mui/material';

import { Colors } from '../utils/Colors';
import Contamination from '../images/OCDf_Icons_512x512-contamination.png';
import Harm from '../images/OCDf_Icons_512x512-harm.png';
import Perfectionism from '../images/OCDf_Icons_512x512-perfectionism.png';
import Relationship from '../images/OCDf_Icons_512x512-relationships.png';
import Scrupulosity from '../images/OCDf_Icons_512x512-scrupulosity.png';
import Somatic from '../images/OCDf_Icons_512x512-somantic.png';
import OrderSymetry from '../images/OCDf_Icons_512x512-order_symmetry.png';
import SexualOrientation from '../images/OCDf_Icons_512x512-sexual_orentation.png';

interface OcdTypeFilterCardProps {
  type: string;
  addFilter: (type: string) => void;
  removeFilter: (type: string) => void;
  clear?: boolean;
}
const ocdTypes: Record<string, any> = {
  Contamination,
  Harm,
  'Order & Symmetry': OrderSymetry,
  Perfectionism,
  Relationship,
  Scrupulosity,
  'Sexual Orientation/POCD': SexualOrientation,
  Somatic
};
export function OcdTypeFilterCard({
  type,
  addFilter,
  removeFilter,
  clear
}: OcdTypeFilterCardProps) {
  const [isSelected, setIsSelected] = React.useState(false);

  React.useEffect(() => {
    if (clear) {
      setIsSelected(false);
    }
  }, [clear]);

  function onClick() {
    if (isSelected) {
      removeFilter(type);
    } else {
      addFilter(type);
    }
    setIsSelected(!isSelected);
  }

  return (
    <Card
      sx={{
        minWidth: '125px',
        minHeight: '150px',
        padding: '15px',
        backgroundColor: isSelected ? Colors.ocdGreen : Colors.lightGray,
        border: `1px solid ${Colors.silverSand}`,
        borderRadius: '15px',
        boxShadow: 0
      }}
      onClick={onClick}
    >
      <Grid container direction="column" textAlign="center">
        <Grid item textAlign="center">
          <img src={ocdTypes[type]} alt="ocd type" style={{ width: 100 }} />
        </Grid>
        <Grid item>
          <Typography variant="h6" align="center">
            {type}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}
